<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('TASKS.ITEMS') }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <tasks-list-filter @setFilters="setFilters" />
      <tasks-list
        ref="tasksList"
        :items="items"
        :meta="meta"
        :options.sync="options"
        @show="show"
      />
      <v-row>
        <v-btn :disabled="!exportIsAvailable()" @click="getTasksExportFile">{{
          $t('BUTTON.EXPORT')
        }}</v-btn>
      </v-row>
    </v-sheet>

    <v-dialog v-model="dialog" persistent max-width="1400px">
      <view-event-task
        v-if="taskId"
        :id="taskId"
        @updated="cancelDialogAndRefresh"
        @removed="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      ></view-event-task>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import TasksList from '../components/TasksList';
import TasksListFilter from '../components/forms/TasksListFilter';
import downloadFile from '@/modules/_global/mixins/download-file';
import { dateFormatUnderscore } from '../../_global/filters';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'TasksPage',

  components: {
    TasksList,
    TasksListFilter,
    ViewEventTask: () =>
      import('@/modules/plannings/components/Event/ViewEventTask'),
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  mixins: [downloadFile, listOptions],

  data() {
    return {
      dialog: false,
      taskId: null,
      error: null,
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      datetimeNow: ''
    };
  },

  created() {
    this.datetimeNow = dateFormatUnderscore(new Date());
  },

  methods: {
    ...mapActions('task', ['getItemsList', 'getTasksExport']),

    getTasksExportFile() {
      this.getTasksExport(this.filters)
        .then(response => {
          let rootName = this.$t('TASKS.ITEMS');

          this.downloadFile(response, `${rootName} ${this.datetimeNow}.xlsx`);
        })
        .catch(error => {
          this.error = error;
        });
    },

    show(item) {
      this.taskId = item.id;
      this.dialog = true;
    },
    cancelDialog() {
      this.dialog = false;
      this.taskId = null;
    },
    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
    },

    exportIsAvailable() {
      if (!this.items || !this.items.length) {
        return false;
      }

      return Object.values(this.options).some(function(e) {
        return Array.isArray(e) ? Boolean(e.length) : Boolean(e);
      });
    }
  }
};
</script>
